
    <fieldmagic-dialog
      label="Defects"
      icon="exclamation-circle"
      [instance]="this"
    >
      <ng-template fieldmagicDialogButtonsTmp>
        <fieldmagic-primary-button
          [label]="(isDisplayingNew$ | async) ? 'Show Existing Defects' : 'Hide Existing Defects'"
          [icon]="(isDisplayingNew$ | async) ? 'eye' : 'eye-slash'"
          [isInProgress]="fetching$ | async"
          [disabled]="(quoting$ | async) || (updating$ | async)"
          (click)="onToggleDefectsList()"
        >
        </fieldmagic-primary-button>

        <fieldmagic-primary-button
          purpose="save"
          [isInProgress]="updating$ | async"
          [disabled]="(quoting$ | async) || (fetching$ | async)"
          (click)="onSave()"
        >
        </fieldmagic-primary-button>

        <fieldmagic-primary-button
          label="Create Quote"
          icon="clipboard-list"
          [isInProgress]="quoting$ | async"
          [disabled]="(updating$ | async) || (fetching$ | async)"
          (click)="onCreateQuote()"
        >
        </fieldmagic-primary-button>
      </ng-template>

      <ng-template fieldmagicDialogContentTmp>
        <div fieldmagicGridRow>
          <div fieldmagicGridColumn="12">
            <table class="table table-bordered">
              <thead>
                <tr>
                  <td>
                    <div class="d-flex justify-content-center">
                      <fieldmagic-checkbox-input
                        [(ngModel)]="selectAll"
                        [useNative]="true"
                        tooltip="Select All"
                        (ngModelChange)="onSelectAll($event)"
                      >
                      </fieldmagic-checkbox-input>
                    </div>
                  </td>
                  <td>
                    <fieldmagic-text
                      content="Asset"
                      purpose="table-header"
                    >
                    </fieldmagic-text>
                  </td>
                  <td>
                    <fieldmagic-text
                      content="Defect"
                      purpose="table-header"
                    >
                    </fieldmagic-text>
                  </td>
                  <td>
                    <fieldmagic-text
                      content="Comments"
                      purpose="table-header"
                    >
                    </fieldmagic-text>
                  </td>
                  <td>
                    <div class="d-flex d-flex-gap align-items-center justify-content-center">
                      <fieldmagic-text
                        content="Acknowledged?"
                        purpose="table-header"
                      >
                      </fieldmagic-text>

                      <fieldmagic-checkbox-input
                        [useNative]="true"
                        [(ngModel)]="acknowledgedAll"
                        tooltip="Click to mark/unmark all as acknowledged"
                        (ngModelChange)="onAcknowledgedAll($event)"
                      >
                      </fieldmagic-checkbox-input>
                    </div>
                  </td>
                  <td>
                    <div class="d-flex d-flex-gap align-items-center justify-content-center">
                      <fieldmagic-text
                        content="Resolved?"
                        purpose="table-header"
                      >
                      </fieldmagic-text>

                      <fieldmagic-checkbox-input
                        [useNative]="true"
                        [(ngModel)]="resolvedAll"
                        tooltip="Click to mark/unmark all as resolved"
                        (ngModelChange)="onResolvedAll($event)"
                      >
                      </fieldmagic-checkbox-input>
                    </div>
                  </td>
                  <td>
                    <fieldmagic-text
                      content="Job"
                      purpose="table-header"
                      alignment="center"
                    >
                    </fieldmagic-text>
                  </td>
                  <td>
                    <fieldmagic-text
                      content="Quote"
                      purpose="table-header"
                      alignment="center"
                    >
                    </fieldmagic-text>
                  </td>
                  <td>
                    <fieldmagic-text
                      content="Date Reported"
                      purpose="table-header"
                    >
                    </fieldmagic-text>
                  </td>
                </tr>
              </thead>

              <ng-container *ngIf="fetching$ | async">
                <tbody>
                  <tr class="text-center">
                    <td colspan="7">
                      <fieldmagic-icon [spin]="true"></fieldmagic-icon>
                    </td>
                  </tr>
                </tbody>
              </ng-container>

              <ng-container *ngIf="! (fetching$ | async)">
                <tbody *ngIf="faults$ | async as faults">
                  <tr
                    *ngIf="faults | blank"
                    class="text-center"
                  >
                    <td colspan="9">{{ 'No defects recorded..' | translate }}</td>
                  </tr>

                  <tr *ngFor="let fault of faults; let fault_index = index;">
                    <td width="1%">
                      <div class="d-flex justify-content-center">
                        <fieldmagic-checkbox-input
                          [(ngModel)]="fault.selected"
                          [useNative]="true"
                          tooltip="Select Asset"
                          (ngModelChange)="onAssetSelect()"
                        >
                        </fieldmagic-checkbox-input>
                      </div>
                    </td>

                    <td width="6%">
                      <a
                        target="_blank"
                        [routerLink]="['/assets', fault.asset_id]"
                      >
                        {{ computeAssetDisplayedText(fault) }}
                      </a>
                    </td>

                    <td
                      width="10%"
                      [style.color]="fault.color | bg_text_color"
                      [style.background]="fault.color"
                    >
                      {{ '(%s) %s' | sprintf: [fault.severity, fault.fault] }}
                    </td>
                    <td width="10%">
                      <fieldmagic-textarea-input
                        [(ngModel)]="fault.comments"
                        [standalone]="true"
                        placeholder="Add comments..."
                        [expandable]="true"
                        (ngModelChange)="emitChanges(fault_index)"
                      >
                      </fieldmagic-textarea-input>
                    </td>
                    <td width="2%">
                      <div class="d-flex d-flex-gap justify-content-center align-items-center">
                        <fieldmagic-checkbox-input
                          [useNative]="true"
                          [(ngModel)]="fault.acknowledged"
                          tooltip="Mark as acknowledged"
                          (ngModelChange)="emitChanges(fault_index)"
                        >
                        </fieldmagic-checkbox-input>

                        <fieldmagic-icon
                          *ngIf="fault.acknowledged && (fault.date_acknowledged | filled)"
                          tooltip="{{ 'Date Acknowledged: %s' | translate | sprintf: [fault.date_acknowledged] }}"
                          [icon]="[{
                            icon: 'info-circle',
                            klass: 'text-info'
                          }]"
                        >
                        </fieldmagic-icon>
                      </div>
                    </td>
                    <td width="2%">
                      <div class="d-flex d-flex-gap justify-content-center align-items-center">
                        <fieldmagic-checkbox-input
                          [useNative]="true"
                          [(ngModel)]="fault.resolved"
                          tooltip="Mark as resolved"
                          (ngModelChange)="emitChanges(fault_index)"
                        >
                        </fieldmagic-checkbox-input>

                        <fieldmagic-icon
                          *ngIf="fault.resolved"
                          [icon]="[{
                            icon: 'info-circle',
                            klass: 'text-info'
                          }]"
                          tooltip="Click to add/view resolution notes"
                          (click)="onAddResolutionNotes(fault_index)"
                        >
                        </fieldmagic-icon>

                      </div>
                    </td>
                    <td width="5%">
                      <div class="d-flex justify-content-center">
                        <fieldmagic-text-link
                          [segments]="(fault.job_text | filled) ? ['/jobs', fault.job_id] : []"
                          [label]="(fault.job_text | filled) ? ('#%06d' | sprintf: [fault.job_text]) : null"
                          [openNewTab]="true"
                        >
                        </fieldmagic-text-link>
                      </div>
                    </td>
                    <td width="5%">
                      <div class="d-flex justify-content-center">
                        <fieldmagic-text-link
                          [segments]="(fault.opportunity_text | filled) ? ['/opportunities', fault.opportunity_id] : []"
                          [label]="(fault.opportunity_text | filled) ? ('#%06d' | sprintf: [fault.opportunity_text]) : null"
                          [openNewTab]="true"
                        >
                        </fieldmagic-text-link>
                      </div>
                    </td>
                    <td width="6%">
                      <div class="d-flex d-flex-gap align-items-center">
                        <span>{{ fault.date_reported }}</span>

                        <fieldmagic-icon
                          [icon]="[{
                            icon: 'info-circle',
                            klass: 'text-info'
                          }]"
                          tooltip="{{ 'Reported By: %s' | translate | sprintf: [fault.reported_by_text] }}"
                        >
                        </fieldmagic-icon>

                        <a
                          *ngIf="fault.image_path | filled"
                          href="{{ fault.image_url }}"
                          target="_blank"
                          matTooltip="{{ 'View Photo' | translate }}"
                          class="btn btn-link"
                        >
                          <fieldmagic-icon
                            icon="file-image"
                          >
                          </fieldmagic-icon>
                        </a>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </ng-container>
            </table>
          </div>
        </div>
      </ng-template>
    </fieldmagic-dialog>
  